import { ITypedReduxAction } from '../../../types/redux/actionType';

export enum EResetPostCardNewsActionType {
  Reset = 'postCardNews/resetPostCardNews',
}

export type TResetPostCardNews = ITypedReduxAction<EResetPostCardNewsActionType.Reset>;
